module.exports = __webpack_public_path__ + "media/valentines_tipping_tier_2-c49579724ea2df4739313f1195ffeeff.mp3";